var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _vm.showMsg
          ? _c(
              "div",
              {
                staticClass: "alert alert-danger alert-dismissible fade show",
                attrs: { role: "alert" }
              },
              [
                _vm._v("\n      " + _vm._s(_vm.msg) + "\n      "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "alert",
                      "aria-label": "Fechar"
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.hideMessage()
                      }
                    }
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×")
                    ])
                  ]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showSuccessMsg
          ? _c(
              "div",
              {
                staticClass: "alert alert-success alert-dismissible fade show",
                attrs: { role: "alert" }
              },
              [
                _vm._v("\n      " + _vm._s(_vm.successMsg) + "\n      "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "alert",
                      "aria-label": "Fechar"
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.hideMessage()
                      }
                    }
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×")
                    ])
                  ]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8" }, [
          _c(
            "button",
            {
              staticClass: "btn donation",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.showAddDonation()
                }
              }
            },
            [_vm._v("Adicionar doação manual")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.exportDonations()
                }
              }
            },
            [_vm._v("Exportar para Planilha")]
          )
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c(
              "b-tabs",
              { staticClass: "donations-lists" },
              [
                _c("b-tab", { attrs: { title: "Doações Únicas" } }, [
                  _vm.donations && _vm.donations.length > 0
                    ? _c("table", { staticClass: "donations table" }, [
                        _c("thead", [
                          _c("th", [_vm._v("Data")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Valor")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Doador")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Status")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Detalhes")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.donations, function(d) {
                            return _c("tr", { key: d.DonationId }, [
                              _c("td", { attrs: { width: "10%" } }, [
                                _vm._v(_vm._s(_vm.getDate(d.timestamp)))
                              ]),
                              _vm._v(" "),
                              _c("td", { attrs: { width: "10%" } }, [
                                _vm._v(
                                  "R$ " +
                                    _vm._s(d.value) +
                                    " (" +
                                    _vm._s(d.paymentType) +
                                    ")"
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { attrs: { width: "10%" } }, [
                                _vm._v(
                                  _vm._s(d.fullname) +
                                    " " +
                                    _vm._s(d.email ? "(" + d.email + ")" : "")
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { attrs: { width: "10%" } }, [
                                _vm._v(_vm._s(_vm.getStatus(d.paymentStatus)))
                              ]),
                              _vm._v(" "),
                              _c("td", { attrs: { width: "10%" } }, [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        $event.preventDefault()
                                        return _vm.showDonationDetail(d)
                                      }
                                    }
                                  },
                                  [_vm._v("Ver")]
                                ),
                                _vm._v(" "),
                                d.manualDonation
                                  ? _c(
                                      "a",
                                      {
                                        attrs: { href: "" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            return _vm.deleteDonation(d)
                                          }
                                        }
                                      },
                                      [_vm._v("| Excluir")]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          }),
                          0
                        )
                      ])
                    : _c("h4", { staticClass: "projects-empty" }, [
                        _vm._v("O projeto não recebeu doações.")
                      ])
                ]),
                _vm._v(" "),
                _c("b-tab", { attrs: { title: "Doações Recorrentes" } }, [
                  _vm.donationsRecurrent && _vm.donationsRecurrent.length > 0
                    ? _c("table", { staticClass: "donations table" }, [
                        _c("thead", [
                          _c("th", [_vm._v("Data")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Valor")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Doador")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Período")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Vencimento")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Detalhes")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.donationsRecurrent, function(d) {
                            return _c("tr", { key: d.DonationId }, [
                              _c("td", [
                                _vm._v(_vm._s(_vm.getDate(d.timestamp)))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "R$ " +
                                    _vm._s(d.value) +
                                    " (" +
                                    _vm._s(d.paymentType) +
                                    ")"
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { attrs: { width: "10%" } }, [
                                _vm._v(
                                  _vm._s(d.fullname) +
                                    " " +
                                    _vm._s(d.email ? "(" + d.email + ")" : "")
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                d.period
                                  ? _c(
                                      "span",
                                      {
                                        class: {
                                          expired: _vm.checkIfMonthlyDonationExpired(
                                            d
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(d.period) +
                                            " meses " +
                                            _vm._s(
                                              _vm.checkIfMonthlyDonationExpired(
                                                d
                                              )
                                                ? "(Expirada)"
                                                : ""
                                            )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.getDate(_vm.dueDate(d).getTime()))
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        $event.preventDefault()
                                        return _vm.showDonationDetail(d)
                                      }
                                    }
                                  },
                                  [_vm._v("Ver")]
                                ),
                                _vm._v(" "),
                                d.manualDonation
                                  ? _c(
                                      "a",
                                      {
                                        attrs: { href: "" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            return _vm.deleteDonation(d)
                                          }
                                        }
                                      },
                                      [_vm._v("| Excluir")]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          }),
                          0
                        )
                      ])
                    : _c("h4", { staticClass: "projects-empty" }, [
                        _vm._v("O projeto não recebe doações recorrentes.")
                      ])
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "donationDetail",
          attrs: { "hide-footer": "", title: "Detalhes da Doação" }
        },
        [
          _vm.donationModal
            ? _c("div", { staticClass: "d-block text-center" }, [
                _c("p", [
                  _vm._v(
                    "Doador: " +
                      _vm._s(_vm.donationModal.fullname) +
                      " (" +
                      _vm._s(_vm.donationModal.email) +
                      ")"
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Valor: R$ " +
                      _vm._s(_vm.convertToReal(_vm.donationModal.value))
                  )
                ]),
                _vm._v(" "),
                _vm.donationModal.paymentMethod
                  ? _c("p", [
                      _vm._v(
                        "Forma de pagamento: " +
                          _vm._s(
                            _vm.donationModal.paymentMethod == "credit_card"
                              ? "Cartão de Crédito"
                              : "Boleto"
                          )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Tipo de Doação: " +
                      _vm._s(
                        _vm.donationModal.type == "single"
                          ? "Simples"
                          : "Recorrente"
                      )
                  )
                ]),
                _vm._v(" "),
                _vm.donationModal.period
                  ? _c("p", [
                      _vm._v(
                        "Período de Doação: " +
                          _vm._s(_vm.donationModal.period) +
                          " meses"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.donationModal.paymentMethod
                  ? _c("p", [
                      _vm._v(
                        "Plataforma de Pagamento: " +
                          _vm._s(_vm.donationModal.paymentType)
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.donationModal.type != "monthly"
                  ? _c("p", [
                      _vm._v(
                        "Status: " +
                          _vm._s(_vm.getStatus(_vm.donationModal.paymentStatus))
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.donationModal.type == "monthly" &&
                _vm.checkIfMonthlyDonationExpired(_vm.donationModal)
                  ? _c("p", { staticClass: "expired" }, [
                      _vm._v("Doação Expirada!")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.donationModal.type == "monthly" &&
                _vm.checkIfMonthlyDonationExpired(_vm.donationModal)
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-danger",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.openMail(_vm.donationModal)
                          }
                        }
                      },
                      [_vm._v("Entrar em contato com Doador")]
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              staticClass: "mt-3",
              attrs: { variant: "outline-danger", block: "" },
              on: { click: _vm.hideModal }
            },
            [_vm._v("Fechar")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "addDonation",
          attrs: { "hide-footer": "", title: "Adicionar doação manual" }
        },
        [
          _vm.showModalMsg
            ? _c(
                "div",
                {
                  staticClass: "alert alert-danger alert-dismissible fade show",
                  attrs: { role: "alert" }
                },
                [
                  _vm._v("\n      " + _vm._s(_vm.msgModal) + "\n      "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "alert",
                        "aria-label": "Fechar"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.hideMessage()
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("form", [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Valor da doação (*)")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "money",
                    rawName: "v-money",
                    value: _vm.money,
                    expression: "money"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.addDonationValue,
                    expression: "addDonationValue"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.addDonationValue },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.addDonationValue = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Data da doação (*)")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: _vm.mask,
                    expression: "mask"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.addDonationDate,
                    expression: "addDonationDate"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.addDonationDate },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.addDonationDate = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Nome do doador (opcional)")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.addDonationName,
                    expression: "addDonationName"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.addDonationName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.addDonationName = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("E-mail do doador (opcional)")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.addDonationEmail,
                    expression: "addDonationEmail"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.addDonationEmail },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.addDonationEmail = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", [_vm._v("Mensagem (*)")]),
                _vm._v(" "),
                _c("vue-editor", {
                  model: {
                    value: _vm.addDonationMessage,
                    callback: function($$v) {
                      _vm.addDonationMessage = $$v
                    },
                    expression: "addDonationMessage"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-checkbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.addDonationHideValue,
                    expression: "addDonationHideValue"
                  }
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.addDonationHideValue)
                    ? _vm._i(_vm.addDonationHideValue, null) > -1
                    : _vm.addDonationHideValue
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.addDonationHideValue,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          (_vm.addDonationHideValue = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.addDonationHideValue = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.addDonationHideValue = $$c
                    }
                  }
                }
              }),
              _vm._v("\n        Ocultar valor na página do projeto\n      ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-checkbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.addDonationHideUser,
                    expression: "addDonationHideUser"
                  }
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.addDonationHideUser)
                    ? _vm._i(_vm.addDonationHideUser, null) > -1
                    : _vm.addDonationHideUser
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.addDonationHideUser,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.addDonationHideUser = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.addDonationHideUser = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.addDonationHideUser = $$c
                    }
                  }
                }
              }),
              _vm._v(
                '\n         Usar nome "Anônimo" na página do projeto\n      '
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              staticClass: "mt-3",
              attrs: { variant: "outline-success", block: "" },
              on: { click: _vm.saveDonation }
            },
            [_vm._v("Salvar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mt-4" }, [
      _c("b", [
        _vm._v(
          'Obs: Doações recorrentes não são atualizadas. Consulte o extrato de doações na sessão "Extrato" ou na sua conta PayPal.'
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39938fb3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39938fb3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manage-project/Donations.vue
// module id = null
// module chunks = 